import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { InfoIcon } from '@core/assets/icons/info_icon'

import './CvParsingDisabledNotice.scss'

const CvParsingDisabledNotice = ({ embedded = false }: { embedded?: boolean }) => {
    const { t } = useTranslation()

    return (
        <div className={clsx('CvParsingDisabledNotice', embedded && 'CvParsingDisabledNotice--embedded')} role="status">
            <span className="CvParsingDisabledNotice__icon">
                <InfoIcon />
            </span>
            <span>{t('13346', 'Automatic CV filling is not enabled for this position')}</span>
        </div>
    )
}

export default CvParsingDisabledNotice
